import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { BugTracker } from 'kb-shared/utilities/bugTracker';

import { DEFAULT_ICON_VERSION, availableIcons } from './Icons.constants';

type IconName = keyof typeof availableIcons;
export type IconProps = {
  className?: string;
  type?: IconType;
  iconTitle?: string;
  ariaHidden?: boolean;
  width?: number | string;
  height?: number | string;
};
export type IconType = 'solid' | 'regular' | 'light' | 'thin';

/**
 * Helper function to create a KB icon component
 * Takes care of className prop or any other future props that need to be passed to all icon components
 * @param {string} type the name of the icon(see Icons.constants.ts for available icons)
 * @returns {JSX.Element}
 */
export const createIcon = (name: IconName) => {
  // function is required  because of displayName
  return function Icon({
    className,
    type = DEFAULT_ICON_VERSION,
    iconTitle,
    ariaHidden = false,
    width,
    height
  }: IconProps = {}) {
    const icon = availableIcons[name][type];
    const title = iconTitle ? iconTitle : availableIcons[name].title;

    if (!icon) {
      BugTracker.notify('Icon not found!');
      return <></>;
    }

    return (
      <FontAwesomeIcon
        icon={icon}
        title={ariaHidden ? undefined : title}
        aria-label={ariaHidden ? undefined : title}
        aria-hidden={ariaHidden}
        focusable={ariaHidden ? 'false' : undefined}
        className={className}
        width={width}
        height={height}
      />
    );
  };
};

export type IconComponent = ReturnType<typeof createIcon>;
